import { ReactNode } from "react";

import { twMerge } from "tailwind-merge";

type Props = {
  className?: string;
  suffix: ReactNode;
  title: ReactNode;
  value: ReactNode;
};

export const Card = (props: Props) => {
  const { className, title, value, suffix } = props;
  return (
    <div
      className={twMerge(
        "border-mistBlue/10 flex flex-col rounded-xl border bg-white/70 px-4 pt-3.5 pb-1.5",
        className
      )}
    >
      <h3 className="inline-flex text-sm whitespace-nowrap">{title}</h3>

      <span className="font-ptm text-basketBallOrange mt-3.5 inline-flex items-end text-4xl tracking-tight whitespace-nowrap">
        {value}
        <span className="ml-2 text-3xl">{suffix}</span>
      </span>
    </div>
  );
};
